function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 0.00375366C5.373 0.00375366 0 5.37675 0 12.0038C0 18.6308 5.373 24.0038 12 24.0038C18.627 24.0038 24 18.6308 24 12.0038C24 5.37675 18.627 0.00375366 12 0.00375366ZM16.597 17.9578L12.006 13.4078L7.451 18.0038L6.046 16.5988L10.593 12.0068L6 7.45475L7.405 6.04975L11.993 10.5928L16.538 6.00375L17.954 7.40675L13.408 11.9938L18 16.5418L16.597 17.9578Z"
});

function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.67c3719b1e165d0b9cd041153ff17faf.svg";
export { ForwardRef as ReactComponent };